// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyBWqa0uxj3TAjvGztTdlCuUcXvc1zYzszo",
    authDomain: "dac6-b72db.firebaseapp.com",
    databaseURL: "https://dac6-b72db.firebaseio.com",
    projectId: "dac6-b72db",
    storageBucket: "dac6-b72db.appspot.com",
    messagingSenderId: "550219515771",
    appId: "1:550219515771:web:7073ddfc4edfde9cf7dfde",
    measurementId: "G-RMPV8DL8HP"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
